import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentType, IStudentService, IStudentServiceCategory } from '../types/appointment_interfaces';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';
import { IAppointmentReasonTypeDatasource } from './../datasources/appointment_reason_type_datasource';

interface IAppointmentsServiceCategoriesQuery {
  categoryList: IStudentServiceCategory[];
  categoryInstructions: string;
  hasCategories: boolean;
  errorMessage: string;
  isCategorySelectionOptional: boolean;
  isStudentBlocked: boolean;
  blockedReason: string;
}

export class AppointmentsServiceCategoriesQuery implements IQuery {
  private _result: IAppointmentsServiceCategoriesQuery;

  constructor(
    private ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {
    ORMMediator.registerQuery(this, ngAppointmentReasonTypeDatasource, ngAppointmentReasonUsersource);
  }

  run(): this {
    let categoryInstructions: string = '';
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    let categoryList: IStudentServiceCategory[] = [];
    let hasCategories: boolean = false;
    let isCategorySelectionOptional = false;
    let errorMessage: string = '';
    let isStudentBlocked = false;
    let blockedReason = '';
    if (selectedType.id) {
      isStudentBlocked = selectedType.is_blocked && !selectedType.can_request;
      blockedReason = selectedType.blocked_reason;
      errorMessage =
        selectedType.instructions.reason_error ||
        `${this.ngAppointmentReasonUsersource.read().selectedType.name} is not available`;

      if (_4.isNull(selectedType.student_service_categories)) {
        isCategorySelectionOptional = true;
      } else {
        isCategorySelectionOptional = false;

        categoryList = _4.sortBy(selectedType.student_service_categories, 'name');
        hasCategories = categoryList.length > 0;
        categoryInstructions = selectedType.instructions.student_service_category;
      }
    }
    this._result = {
      categoryList,
      categoryInstructions,
      hasCategories,
      errorMessage,
      isCategorySelectionOptional,
      isStudentBlocked,
      blockedReason
    };
    return this;
  }

  get result(): IAppointmentsServiceCategoriesQuery {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_service_categories_query.ts